import { biddingClosed, biddingOpen, unscheduled } from "@scripts/generated/domaintables/biddingStates";

export const defaultRfpStatus = [biddingOpen, biddingClosed, unscheduled] as const;
